/**
 * Dropdown pour FAQ
 */  
    // Toggle Collapse
jQuery(document).ready(function($) {
    
    let mobile = window.matchMedia('(min-width: 0px) and (max-width: 768px)');
    let tablet = window.matchMedia('(min-width: 769px) and (max-width: 1024px)');
    let desktop = window.matchMedia('(min-width: 1025px)');
    // Tout est ouvert, on ferme sur Desktop
    if (  desktop.matches && $('.faq li').length ) {
        $('.faq li').removeClass('active')
    }

    $('.faq li').click(function () {
        // console.log('click');
        $(this).toggleClass('active');
    });

    //Ajoute l'animation d'ouverture/fermeture au block yoast/faq-block et acf-custom
    $('.schema-faq .schema-faq-section:first-child').addClass('active');
        $(document).on('click', '.schema-faq .schema-faq-section', function () {
            $('.schema-faq .schema-faq-section').removeClass('active');
            $(this).toggleClass('active');
            /*
            $('.schema-faq .schema-faq-section').each( (index) => {
           
                console.log($(this), $(e.target).closest('.schema-faq-section').get(0))
            
                if ($(this) !== (e.target).closest('.schema-faq-section') )
                    $(this).removeClass('active');
            })
            $(e.target).closest('.schema-faq-section').toggleClass('active');
            */
    });

    //Ajoute l'animation d'ouverture/fermeture au block tabs
    // Activer le premier contenu au chargement
    $('.tabs .tab-content:first').addClass('active');
    $('.tabs .tab-button:first').addClass('active');

    // Clic sur un lien d'onglet
    $(document).on('click', '.tabs .tab-button a', function (e) {
        e.preventDefault();

        const target = $(this).attr('href');

        // Met à jour l’état actif des boutons
        $('.tabs .tab-button').removeClass('active');
        $(this).closest('.tab-button').addClass('active');

        // Met à jour l’état actif des contenus
        $('.tabs .tab-content').removeClass('active');
        $(target).addClass('active');
    });

});